import React from 'react';
import { CustomSelect, CustomText, Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Button, Col, Select } from 'antd';
import PropTypes from 'prop-types';
import { APONTAMENTO } from '../../../services/apontamentoProducao';

const { Option } = Select;

/**
 * Componente Molecule para seletor de requisição
 */
function ApontamentoRequisicaoSelector({
  requisicao: payroll,
  requisicoes: payrolls,
  loading,
  disabled,
  parametrizacao: parameterization,
  tipo: type,
  onRequisicaoChange: onPayrollChange,
  onNovaRequisicaoClick: onNewPayrollClick,
}) {
  return (
    <Col
      xs={24}
      sm={24}
      md={12}
      lg={6}
      xl={6}
      className="requisicao-select-column"
    >
      <Label label="Requisição">
        <CustomSelect
          dropdownMatchSelectWidth={false}
          dropdownStyle={{ 'max-width': '480px' }}
          placeholder="Selecione uma requisição..."
          loading={loading}
          disabled={disabled || !parameterization}
          value={(payroll || {}).id}
          onChange={onPayrollChange}
          dropdownRender={(menu) => (
            <>
              <Button
                type="link"
                onMouseDown={() => {
                  if (parameterization) {
                    onNewPayrollClick();
                  }
                }}
                role="button"
                style={{
                  flex: 'none',
                  padding: '8px',
                  display: 'block',
                  cursor: 'pointer',
                }}
              >
                <CustomText
                  height="24px"
                  fontSize="12px"
                  color="#0b8af7"
                  ellipsis
                  fontWeight={500}
                >
                  + Nova Requisição
                </CustomText>
              </Button>
              {menu}
            </>
          )}
        >
          {payrolls &&
            payrolls.map((item) => (
              <Option
                key={item.id}
                value={item.id}
              >
                <CustomText color={item.status === APONTAMENTO.status.cancelado && 'var(--error)'}>
                  {`Requi. ${item.id} ${type} ${item.descricao == null ? '' : `- ${item.descricao}`}`}
                </CustomText>
              </Option>
            ))}
        </CustomSelect>
      </Label>
    </Col>
  );
}

ApontamentoRequisicaoSelector.propTypes = {
  requisicao: PropTypes.shape({
    id: PropTypes.number,
  }),
  requisicoes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      status: PropTypes.number,
      descricao: PropTypes.string,
    })
  ),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  parametrizacao: PropTypes.shape({
    id: PropTypes.number,
    nome: PropTypes.string,
    email_alerta: PropTypes.string,
    exibe_param_apontamento: PropTypes.bool,
    atual_comp_ap_qtd_dias: PropTypes.number,
  }),
  tipo: PropTypes.string.isRequired,
  onRequisicaoChange: PropTypes.func.isRequired,
  onNovaRequisicaoClick: PropTypes.func.isRequired,
};

ApontamentoRequisicaoSelector.defaultProps = {
  requisicao: undefined,
  requisicoes: [],
  loading: false,
  disabled: false,
  parametrizacao: undefined,
};

export default ApontamentoRequisicaoSelector;
